const topupErrorCodeMap: Record<string, string> = {
  PBWTORepositoryUnavailable: "errors.PBWTORepositoryUnavailable",
  PBWTOInternalServer: "errors.PBWTOInternalServer",
  PBWTOMissingTokenCode: "errors.PBWTOMissingTokenCode",
  PBWTOEmptyField: "errors.PBWTOEmptyField",
  PBWTOInvalidSearchAfter: "errors.PBWTOInvalidSearchAfter",
  PBWTOTopUpFailed: "errors.PBWTOTopUpFailed",
  PBWTOMissingUUID: "errors.PBWTOMissingUUID",
  PBWTOInvalidTenantID: "errors.PBWTOInvalidTenantID",
  PBWTOInvalidUUID: "errors.PBWTOInvalidUUID",
  PBWTOInvalidAmount: "errors.PBWTOInvalidAmount",
  PBWTOInvalidCurrency: "errors.PBWTOInvalidCurrency",
  PBWTOInvalidWalletDetails: "errors.PBWTOInvalidWalletDetails",
  PBWTOInvalidMetadata: "errors.PBWTOInvalidMetadata",
  PBWTOInvalidPaymentData: "errors.PBWTOInvalidPaymentData",
  PBWTOInvalidCountryCode: "errors.PBWTOInvalidCountryCode",
  PBWTOTopUpNotFound: "errors.PBWTOTopUpNotFound",
  PBWTOFetchingTopUpFailed: "errors.PBWTOFetchingTopUpFailed",
  PBWTOCreatingTopUpFailed: "errors.PBWTOCreatingTopUpFailed",
  PBWTOUpdatingTopUpFailed: "errors.PBWTOUpdatingTopUpFailed",
  PBWTOCreateInvoiceFailed: "errors.PBWTOCreateInvoiceFailed",
  PBWTOFetchingCurrencyExchangeFailed: "errors.PBWTOFetchingCurrencyExchangeFailed",
  PBWTOFetchingServiceFeesFailed: "errors.PBWTOFetchingServiceFeesFailed",
  PBWTOFetchingTaxFailed: "errors.PBWTOFetchingTaxFailed",
  PBWTONoAccessToWallet: "errors.PBWTONoAccessToWallet",
  PBWTONoAccessToTopup: "errors.PBWTONoAccessToTopup"
}

export default function topupErrorHandlers(code: string) {
  return topupErrorCodeMap[code] ?? ''
}
